import { createElement, lazy, type ComponentType } from "react";
import { defineWebModule, EmptyState, PageBanner, useShell } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const ReportsHome = lazy(() => import("./web/ReportsHome.js").then((m) => ({ default: m.ReportsHome })));
const ReportPage = lazy(() => import("./web/ReportPage.js").then((m) => ({ default: m.ReportPage })));
/**
 * Data feeds read the company's feed keys and agents, which need the company figures permission (the menu entry needs
 * reports.manage, a module permission). Someone with one and not the other gets the friendly no-access card, not a
 * page of failed calls.
 */
const gated = (permission: string, title: string, Page: ComponentType): ComponentType => function Gated() {
  const { can } = useShell();
  if (can(permission)) return createElement(Page);
  return createElement("div", null, createElement(PageBanner, { title }), createElement("div", { className: "tc-content" }, createElement(EmptyState, { title: "You don't have access to this page", icon: "lock" }, "Data feeds are for the people who look after the company's figures. Ask a company admin if you need them.")));
};
const FeedsPage = gated("company.figures", "Data feeds", lazy(() => import("./web/FeedsPage.js").then((m) => ({ default: m.FeedsPage }))));
const ComparePageIn = gated("company.figures", "Compare feeds", lazy(() => import("./web/ComparePage.js").then((m) => ({ default: m.ComparePage }))));
/** Cloud vs old ETL is part of moving from the old Cloud: not there for any other company (29/10/26). */
const ComparePage: ComponentType = function OldCloudOnly() {
  const { session } = useShell();
  if (session.oldCloud) return createElement(ComparePageIn);
  return createElement("div", null, createElement(PageBanner, { title: "Data feeds" }), createElement("div", { className: "tc-content" }, createElement(EmptyState, { title: "Page not found", icon: "search" }, "There's nothing here.")));
};
const SalesPage = lazy(() => import("./web/SalesPage.js").then((m) => ({ default: m.SalesPage })));
const ManagePage = lazy(() => import("./web/ManagePage.js").then((m) => ({ default: m.ManagePage })));

// The sales drill-down and every report also open inside Shop (/reports/shop…) and Fuel (/reports/fuel…), under
// those sections' tabs (22/10/26); the pages see where they are from the address (web/where.ts).
export default defineWebModule({ manifest, pages: {
  "": ReportsHome, "/view": ReportPage, "/feeds": FeedsPage, "/feeds/compare": ComparePage, "/manage": ManagePage, "/sales": SalesPage,
  "/shop": SalesPage, "/shop/view": ReportPage, "/fuel": SalesPage, "/fuel/view": ReportPage,
} });
